import { ImagesActionType, IMAGES, CLEAR_IMAGES } from './images.action';

interface IState {
    images: string | null;
}

const INITIAL_STATE: IState = {
    images: null,
};

export default function questionReducer(
    state: IState = INITIAL_STATE,
    action: ImagesActionType
): IState {
    switch (action.type) {
        case IMAGES:
            return {
                ...state,
                images: action.payload.images,
            };
        case CLEAR_IMAGES:
            return {
                ...state,
                images: null,
            };
        default:
            return state;
    }
}
